const locationPos = {
  data() {
    return {
      locations: {
        제주: {
          x: 126.588641,
          y: 33.398883,
          centerX: 126.539392,
          centerY: 33.396194
        },
        경기: {
          x: 126.831188,
          y: 37.199493,
          centerX: 126.831188,
          centerY: 37.199493
        }
      }
    };
  },

  methods: {
    getLocationPos(value) {
      if(value != null) {
        return { x: this.locations[value].x, y: this.locations[value].y };
      }
    },

    getCenterPos(value) {
      if(value != null) {
        return { x: this.locations[value].centerX, y: this.locations[value].centerY };
      }
    }
  }
};

export default locationPos;
